
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  const scrollToJoin = () => {
    const element = document.getElementById('join');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-charcoal">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/38f054c317b080073d045f2c6a518569.jpg)',
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-br from-charcoal via-charcoal/95 to-primary/20"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-8 text-center py-32">
        <h1 className="font-poppins font-black text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-white mb-8 leading-none tracking-tight">
          More Than One Voice.
        </h1>
        <h2 className="font-poppins font-black text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-white mb-12 leading-none tracking-tight">
          More Than One Path.
        </h2>
        <div className="font-poppins font-black text-5xl sm:text-6xl md:text-7xl lg:text-8xl mb-16 leading-none tracking-tight">
          <span className="text-primary">MasDeUna.</span>
        </div>

        <p className="font-inter text-xl sm:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed font-medium">
          We need more Latinas in leadership, entrepreneurship, and decision-making spaces. This is about power, presence, and purpose.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <button
            onClick={() => navigate('/join')}
            className="bg-primary hover:bg-primary/90 text-white font-inter font-bold text-xl px-12 py-5 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
          >
            Join the Movement
          </button>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
